module.exports = __webpack_public_path__ + "img/prizes-bg.a82358f7.png";